<script lang="ts">
  import Icon from 'src/components/Icon.svelte';
  import RavelyIcon from 'src/icons/RavelyIcon.svelte';
  import { createEventDispatcher } from 'svelte';
  import { quintInOut } from 'svelte/easing';

  export let showClose: boolean = false;

  const baseWidth = 50;
  const buttonLogoTransition = (_node, { duration, delay }) => {
    return {
      css: (t) => {
        return `
          max-width: ${t * 200 + baseWidth}px;
          opacity: ${t};
        `;
      },
      easing: quintInOut,
      duration,
      delay,
    };
  };

  const buttonHideTransition = (_node, { duration, delay }) => {
    return {
      css: (t) => {
        return `
          transform: rotate(${(1 - t) * 180}deg);
          opacity: ${t};
        `;
      },
      easing: quintInOut,
      duration,
      delay,
    };
  };

  const dispatch = createEventDispatcher();

  function handleClick() {
    dispatch('click');
  }
</script>

<button
  aria-expanded={showClose}
  aria-label="Reviews"
  class="shadow-2 button {$$restProps.class || ''}"
  on:click={handleClick}
>
  {#if !showClose}
    <div
      class="buttonContents"
      in:buttonLogoTransition={{ duration: 300, delay: 350 }}
      out:buttonLogoTransition={{ duration: 300, delay: 0 }}
    >
      <RavelyIcon class="mainIcon" />
      <span class="text">Reviews</span>
    </div>
  {:else}
    <div
      class="buttonContents closeContent"
      in:buttonHideTransition={{ duration: 300, delay: 350 }}
      out:buttonHideTransition={{ duration: 300, delay: 0 }}
    >
      <Icon name="eva-chevron-down" />
    </div>
  {/if}
</button>

<style lang="scss">
  $size: 50px;
  $iconSize: $size/2;

  .button {
    padding: 0;
    margin: 0;
    padding: 0;
    background-color: var(--primary);
    border-radius: $size / 2;
    max-height: $size;
    cursor: pointer;
    overflow: hidden;
  }

  .buttonContents {
    height: $size;
    padding: 0 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    .text {
      color: var(--theme-text-color);
      font-size: 20px;
      margin-left: 8px;
    }
  }

  .closeContent {
    width: $size;
    color: var(--theme-text-color);
    font-size: 28px;
  }

  :global(.mainIcon) {
    fill: var(--theme-text-color);
    width: $iconSize;
    height: $iconSize;
  }
</style>
